export enum TableSortId {
  EmployeeId = 'employeeId',
  FirstName = 'firstName',
  LastName = 'lastName',
  FullName = 'fullName',
  Markup = 'markup',
  InactiveOrFokParameterChoices = 'inactiveOrFokParameterChoices',
  AttributablePay = 'attributablePay',
  PayAmount = 'payAmount',
  HasError = 'hasError',
}

export enum InvoicesTableSortId {
  InvoiceOcrNumber = 'ocrNumber',
  InvoiceStatus = 'invoiceStatus',
  InvoiceType = 'invoiceType',
  InvoiceDate = 'invoiceDate',
  InvoiceDueDate = 'invoiceDueDate',
  InvoiceAmount = 'invoiceAmount',
}

export enum MarkupsTableSortId {
  FokId = 'fokId',
  FokText = 'fokText',
  ValidFromDate = 'validFromDate',
  ValidToDate = 'validToDate',
}

export enum PayReportsTableSortId {
  ReportingPeriods = 'reportingPeriods',
  Status = 'status',
}

export enum ReportHistoryTableSortId {
  Date = 'date',
  Status = 'status',
  Organization = 'organization',
  Administrator = 'administrator',
  Receipt = 'receipt',
  Documents = 'documents',
}
export enum PayHistoryTableSortId {
  Organization = 'organization',
  Id = 'id',
  FirstName = 'firstName',
  LastName = 'lastName',
  Period = 'period',
  GrossSalary = 'grossSalary',
}
